import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyCreationStep, PropertyDpeDto, PropertyDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyMissingInfoUtils } from '../../../../utils/property-missing-info.utils';
import { EtxePropertySectionReminderComponent } from '../../../property-section-reminder/property-section-reminder.component';
import { PropertyDpeDisplayComponent } from '../display/dpe-display.component';
import { PropertyDpeFormComponent } from '../form/dpe-form.component';

@Component({
  selector: 'etxe-property-dpe-edit',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyDpeDisplayComponent,
    PropertyDpeFormComponent,
    EtxePropertySectionReminderComponent,
  ],
  templateUrl: './dpe-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDpeEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);

  isExpanded = signal<boolean>(true);

  missingItems = computed(() =>
    PropertyMissingInfoUtils.getMissingItemsByStep(this.property(), PropertyCreationStep.DPE),
  );

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyDpeDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyDpeDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
